import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Pencil, EyeOff } from 'lucide-react';
import { IgnorarDialog } from './IgnorarDialog';

const fmtCLP = (n) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n || 0);

const FilaPagoOC = ({ d, onChange }) => {
  const navigate = useNavigate();
  const [ignorar, setIgnorar] = useState(false);
  return (
    <tr className="border-b align-top hover:bg-muted/40" data-testid={`fila-pago-oc-${d.numero_oc}`}>
      <td className="p-2 font-mono text-xs whitespace-nowrap">
        <div className="font-semibold">OC {d.numero_oc}</div>
        <div className="text-muted-foreground">{d.fecha_oc}</div>
        <Badge variant={d.aprobada ? 'default' : 'secondary'} className="mt-1 text-[10px]">{d.aprobada ? 'Aprobada' : 'Pendiente VB'}</Badge>
      </td>
      <td className="p-2 text-sm">
        <div className="font-medium">{d.nombre_erp}</div>
        <div className="text-xs text-muted-foreground font-mono">{d.rut_canonico} · {d.source} · {d.creado_por}</div>
        <div className="text-xs text-muted-foreground">{fmtCLP(d.total)}</div>
      </td>
      <td className="p-2 text-xs">
        <div>Condición: <span className="font-medium">{d.condicion_pago || '—'}</span> {d.condicion_pago_codigo && <span className="font-mono text-muted-foreground">({d.condicion_pago_codigo})</span>}</div>
        <div>Medio de pago: <span className="font-medium">{d.medio_pago_nombre || d.medio_pago_codigo || '—'}</span></div>
      </td>
      <td className="p-2 text-xs text-red-800" data-testid="pago-oc-problemas">
        {(d.problemas || []).map((p, i) => <div key={i}>⛔ {p}</div>)}
      </td>
      <td className="p-2 whitespace-nowrap">
        <div className="flex gap-1">
          <Button size="sm" onClick={() => navigate(`/compras/editar-oc/${d.numero_oc}`)} data-testid="btn-editar-oc">
            <Pencil className="w-4 h-4 mr-1" /> Editar OC
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setIgnorar(true)} title="Ignorar (caso justificado)" data-testid="btn-ignorar-pago-oc">
            <EyeOff className="w-4 h-4" />
          </Button>
        </div>
        <IgnorarDialog open={ignorar} onOpenChange={setIgnorar} id={d.id} descripcion={`OC ${d.numero_oc} · ${d.nombre_erp}`} onDone={onChange} />
      </td>
    </tr>
  );
};

export const TablaPagoOC = ({ items, onChange }) => {
  if (!items.length) return <p className="text-sm text-muted-foreground py-8 text-center" data-testid="tabla-pago-oc-vacio">Todas las OCs tienen condición vigente y medio de pago cuando corresponde.</p>;
  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full text-sm" data-testid="tabla-pago-oc">
        <thead className="bg-muted/60 text-xs uppercase text-muted-foreground">
          <tr>
            <th className="p-2 text-left">OC</th>
            <th className="p-2 text-left">Proveedor</th>
            <th className="p-2 text-left">Datos actuales</th>
            <th className="p-2 text-left">Problema</th>
            <th className="p-2 text-left">Acción</th>
          </tr>
        </thead>
        <tbody>{items.map((d) => <FilaPagoOC key={d.id} d={d} onChange={onChange} />)}</tbody>
      </table>
    </div>
  );
};
